import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { startCase } from "lodash";

import { formatDateShort } from "@ds-developer/frontend";

import { DrivingDetailsProps } from "../types";

const useStyles = makeStyles({
  subTitle: {
    color: colors.blueGrey[200],
  },
});

const Qualifications: React.FC<Pick<DrivingDetailsProps, "certifications">> = ({
  certifications = [],
}) => {
  const classes = useStyles();

  return certifications && certifications.length ? (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2}>Type</TableCell>
          <TableCell>Expiry</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {certifications.map(certification => (
          <TableRow key={certification.id}>
            <TableCell colSpan={2}>
              <Typography variant="body2" data-test={`qualification-title`}>
                {startCase(certification.type)}
              </Typography>
              <Typography
                className={classes.subTitle}
                variant="body2"
                data-test={`qualification-subtitle`}
              >
                {certification.reference}
              </Typography>
            </TableCell>

            <TableCell data-test={`qualification-expiry`}>
              {certification.toDate &&
                formatDateShort(new Date(certification.toDate))}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  ) : null;
};

export default Qualifications;
